import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";
import { useTranslation } from "react-i18next";

const TestimonialSection = () => {
  const { t } = useTranslation('testimonials');
  const testimonials = (t('testimonials', { returnObjects: true }) as Array<{
    quote: string;
    author: string;
    role: string;
    initials: string;
    industry?: string;
    company?: string;
    rating?: number;
  }>) || [];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <Badge variant="outline" className="mb-4">{t('badge')}</Badge>
          <h2 className="text-4xl font-bold mb-6">{t('title')}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('description')}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="relative hover:shadow-elegant transition-smooth group">
              <CardContent className="p-6">
                <div className="absolute -top-4 left-6">
                  <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center">
                    <Quote className="w-4 h-4 text-accent-foreground" />
                  </div>
                </div>
                
                <div className="flex items-center mb-4 mt-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-accent text-accent" />
                  ))}
                </div>
                
                <blockquote className="text-muted-foreground mb-6 italic leading-relaxed">
                  "{testimonial.quote}"
                </blockquote>
                
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-accent text-accent-foreground rounded-full flex items-center justify-center font-semibold text-sm mr-3">
                    {testimonial.initials}
                  </div>
                  <div>
                    <div className="font-semibold text-foreground">{testimonial.author}</div>
                    <div className="text-sm text-muted-foreground">{testimonial.role}</div>
                    {testimonial.industry && (
                      <div className="text-xs text-primary mt-1">{testimonial.industry}</div>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;